import React, { useRef, useState, useEffect, useContext } from "react";
import PageNav from "../components/PageNav";
import classNames from "classnames";
import NewNotes from "./NewNotes";
import CategorizedNotes from "../components/CategorizedNotes";
import { Notesvg } from "../svg/Notesvg";
import Featured from '../components/Featured';
// import useOnClick from '../components/common/ClosePopUp';
import { AuthContext } from "../context/AuthContext";
import axios from 'axios';
import Button from '../components/common/Button';
import { animated, useSpring } from "react-spring";
import loadingSpin from '../images/loadingSpin.gif';
import NtwrkErrMsg from "../components/common/NtwrkErrMsg";
import EmptyContent from "../components/common/EmptyContent";
import { categorizeNotes } from "../util/nigerianSchoolCalendar";

const Notes = () => {
    const authContext = useContext(AuthContext);
    // const studentId = authContext.studentInfo[0].studentId;
    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'))?.[0] || {};
    const id = JSON.parse(localStorage.getItem('studentInfo'));
    const studentId = id[0].studentId;
    const schoolDomain = localStorage.getItem('schoolDomain');
    const deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;

    const [fetchedNotes, setFetchedNotes] = useState([]);
    // const [noNotes, setNoNotes] = useState(false);
    const [newNote, setNewNote] = useState(true);
    const [searchedNote, setSearchedNote] = useState(false);
    const [fetchedSearchedNotes, setFetchedSearchedNotes] = useState([]);
    const [date, setDate] = useState('');
    const [selectedSession, setSelectedSession] = useState(studentInfo?.current_session || '');
    const [selectedTerm, setSelectedTerm] = useState(studentInfo?.current_term || '');
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [ fetchError, setFetchError ] = useState(false);
    const [ loadingAll, setLoadingAll ] = useState(false);

    // Session and term options
    const sessionOptions = [
        '2024/2025',
        '2025/2026', 
        '2026/2027',
        '2027/2028'
    ];

    const termOptions = [
        'First Term',
        'Second Term', 
        'Third Term'
    ];

    // Filter notes based on search query
    const filteredNotes = (notes) => {
        if (!searchQuery) return notes;
        return notes.filter(note => 
            note.subjectname?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            note.subtopic?.toLowerCase().includes(searchQuery.toLowerCase())
        );
    };

    // Get categorized and filtered notes
    const getCategorizedNotes = (notes) => {
        const filtered = filteredNotes(notes);
        return categorizeNotes(filtered, selectedTerm, selectedSession);
    };

    useEffect(() => {
        const getNotes = async () => {
            try {
                setLoadingAll(true)
                const { data } = await axios.get(
                    `${authContext.baseUrl}/student/lessonNotes/${schoolDomain}/${studentId}/${deploymentIdx}?session=${selectedSession}&term=${selectedTerm}&class=${studentInfo.current_class}&admissionnumber=${studentInfo.admissionnumber}`
                );
                console.log({studentInfo})
                if(data.status) {
                    setSearchedNote(true);
                    setNewNote(true);
                    data.data.length > 0 && setFetchedNotes(data.data[0].Available_Notes);
                    setLoadingAll(false)
                } else {
                    setLoadingAll(false)
                }
                // console.log(data.data[0].Available_Notes);
            } catch (error) {
                // console.log(error, 'fetchError');
                setLoadingAll(false)
                setFetchError(true);
            }
        };
        getNotes()
    }, [selectedSession, selectedTerm])

    const showNoNotes = classNames({
        "flex justify-center w-full mt-16": true,
    });

    const Heading = () => (
        <>
            <span className="text-2xl leading-7 text-white mt-1"> Notes </span>
        </>
    );
    const pageSvg = () => (
        <>
            <Notesvg />
        </>
    );

    const ref = useRef()

    // useOnClick(ref, ()=> setDisplayDropdown(false))

    const handleChange = (e) => {
        setDate(e.target.value)
    };

    const [isSearch, setIsSearch] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            setIsSearch(!!date?.length);
            setLoading(true);
            setNewNote(false);
            const { data } = await axios.get(`${authContext.baseUrl}/student/lessonNotes/${schoolDomain}/${studentId}/${deploymentIdx}?datefilter=${date}`);
            // console.log(data.data)
            // console.log(date);
            data.status && setSearchedNote(true);
            setLoading(false);
            if (data.data.length === 0) {
                setSearchedNote(false);
            };
            data.data.length && setFetchedSearchedNotes(data.data[0].Available_Notes);
        } catch (error) {
            setFetchError(true)
            // console.log(error)
        }
    };

    const transitionStyles = useSpring({
        to: [
        { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 1000 }
    });

    return (
        <>
            <div className="px-4 sm:flex sm:px-0">
                <animated.div style={transitionStyles} className="w-full sm:w-2/3">
                    <PageNav Heading={Heading} PageSvg={pageSvg} />
                    <div className="pt-6 w-full">
                        {/* Search Bar */}
                        <div className="mb-4">
                            <input
                                type="text"
                                placeholder="Search notes by subject or topic..."
                                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>

                        {/* Filters */}
                        <div className="bg-gray-50 p-4 rounded-lg mb-4">
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                {/* Session Filter */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Session</label>
                                    <select
                                        value={selectedSession}
                                        onChange={(e) => setSelectedSession(e.target.value)}
                                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <option value="">All Sessions</option>
                                        {sessionOptions.map((session) => (
                                            <option key={session} value={session}>{session}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Term Filter */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Term</label>
                                    <select
                                        value={selectedTerm}
                                        onChange={(e) => setSelectedTerm(e.target.value)}
                                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <option value="">All Terms</option>
                                        {termOptions.map((term) => (
                                            <option key={term} value={term}>{term}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Date Filter */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Date Filter</label>
                                    <form onSubmit={handleSubmit} className="flex">
                                        <input
                                            type="date"
                                            value={date}
                                            onChange={handleChange}
                                            className="flex-1 p-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                        <Button
                                            type="submit"
                                            text="Search"
                                            loading={loading}
                                            className="rounded-l-none"
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>

                        {
                            loadingAll &&
                            <div className='flex justify-center w-full h-full my-24'>
                                <img src={loadingSpin} alt='loading...' />
                            </div>
                        }

                        {
                            !isSearch && (!fetchedNotes || fetchedNotes?.length === 0) && !loadingAll && !fetchError &&
                            <div className='flex justify-center w-full sm:mt-16'>
                                <EmptyContent message='No notes' moreMessage='Notes uploaded by teachers would be displayed here' />
                            </div>
                        }

                        {
                            isSearch && searchedNote === false && !fetchError && !loadingAll && 
                            <div className={showNoNotes}>
                                <EmptyContent message='No notes for this date' moreMessage='Notes uploaded by teachers would be displayed here' />
                            </div>
                        }

                        {
                            newNote && fetchedNotes?.length > 0 &&
                            <div className="mt-4 w-full">
                                {(() => {
                                    const { currentNotes, olderNotes } = getCategorizedNotes(fetchedNotes);
                                    return (
                                        <CategorizedNotes 
                                            currentNotes={currentNotes} 
                                            olderNotes={olderNotes} 
                                        />
                                    );
                                })()}
                            </div>
                        }

                        {
                            searchedNote && fetchedSearchedNotes?.length > 0 &&
                            <div className="mt-4 w-full">
                                {(() => {
                                    const { currentNotes, olderNotes } = getCategorizedNotes(fetchedSearchedNotes);
                                    return (
                                        <CategorizedNotes 
                                            currentNotes={currentNotes} 
                                            olderNotes={olderNotes} 
                                        />
                                    );
                                })()}
                            </div>
                        }

                        {
                            fetchError &&
                            <NtwrkErrMsg errMsg = 'Oops! Something Went Wrong' showReload = { true } />
                        }
                    </div>
                </animated.div>
                <div className="w-full sm:w-1/3 sm:mx-4 mt-6">
                    <Featured />
                </div>
            </div>
        </>
    )
}

export default Notes;